import { createApi } from "@reduxjs/toolkit/query/react";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import baseQueryWithReAuth from "src/business.InterfaceLayer/store/services/utils.service/baseQueryWithReAuth";
import authApiPatchQueries from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/endpoints/PATCH";
import authApiPostQueries from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/endpoints/POST";
import authApiGetQueries from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/endpoints/GET";
import authApiDeleteQueries from "./endpoints/DELETE";

export const authApi = createApi({
	baseQuery: baseQueryWithReAuth,
	reducerPath: `${MAIN_PATHS.AUTHORIZATION}Api`,
	tagTypes: [`${MAIN_PATHS.AUTHORIZATION}TAG`],
	endpoints: (build) => ({
		...authApiGetQueries(build),
		...authApiPatchQueries(build),
		...authApiPostQueries(build),
		...authApiDeleteQueries(build),
	}),
});

export const {
	usePostRegistrationMutation,
	usePostRegistrationCheckEmailMutation,
	usePostLoginMutation,
	usePostRecoveryPasswordEmailMutation,
	usePostRecoveryPasswordMutation,
	//
	useGetMeQuery,
} = authApi;
